import { type IValidatedResponse, putRequest } from '../../httpClient';
import type { ISaveBookmarkV1Request } from './save-bookmark-v1-request';
import {
  type ISaveBookmarkV1Response,
  saveBookmarkV1ResponseSchema,
} from './save-bookmark-v1-response';

export async function saveBookmarkV1Api({
  challengeId,
  ...body
}: ISaveBookmarkV1Request): Promise<IValidatedResponse<ISaveBookmarkV1Response>> {
  return putRequest<ISaveBookmarkV1Response>({
    path: `/bookmarks/challenges/${challengeId}/v1`,
    body,
    schema: saveBookmarkV1ResponseSchema,
  });
}
